import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoints } from '@core/constants';
import { AppInfo } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  
  private readonly myApplications = ApiEndpoints.getMyApplications;
  private readonly ceoApplications = ApiEndpoints.getCEOApplications;
  private readonly userApplications = ApiEndpoints.userApplications;
  constructor(private httpClient: HttpClient) { }

  getApplications(){
    return this.httpClient.get<AppInfo[]>(this.myApplications);
  }


  getCEOApplications() {
    return this.httpClient.get<AppInfo[]>(this.ceoApplications);
  }

  getUserApplications(userID:any){
    return this.httpClient.get<AppInfo[]>(this.userApplications + userID);
  }
  
}
